<template>
	<div class="my-8 w-full mx-auto">
		<div>
			<div class="flex justify-between items-center">
				<div class="">
					<h3 class="text-ihh-midnight-gray text-base sm:text-base font-semibold flex w-full">Billing Address</h3>
				</div>
				<!-- <div class="my-3 items-center flex">
					<div class="flex items-center justify-end w-full">
						<label class="custom-checkbox relative inline-block overflow-hidden w-4 h-4 bg-transparent rounded border border-gray-300 cursor-pointer mr-2">
							<input type="checkbox" v-model="localBillingMatchesShipping" class="absolute opacity-0 w-0 h-0" />
							<span class="checkmark absolute inset-0 flex items-center justify-center hidden text-ihh-white/90 text-lg">✓</span>
						</label>
						<div class="text-ihh-slate-gray text-sm items-center">Billing matches shipping</div>
					</div>
				</div> -->
			</div>

			<!-- Address Book Toggle (selected address / create new address) -->
			<div v-if="showAddressToggle" class="mb-4 mt-2 relative">
				<div
					@click="toggleAddressList"
					class="w-full border mb-0 rounded h-auto p-2 text-sm text-ihh-gray-address pl-2 flex justify-between items-center cursor-pointer"
					:class="showAddressList ? 'rounded-b-none border-b-0' : ''"
				>
					<div>Select a saved address</div>
					<!-- Dropdown arrow icon -->
					<div>
						<svg class="" height="24" viewBox="0 0 48 48" width="24" xmlns="http://www.w3.org/2000/svg">
							<path d="M14 20l10 10 10-10z" />
							<path d="M0 0h48v48h-48z" fill="none" />
						</svg>
					</div>
				</div>

				<!-- Address dropdown list -->
				<div v-if="showAddressList" class="absolute z-10 w-full bg-white border rounded rounded-t-none shadow-xl max-h-60 overflow-y-auto text-xs text-ihh-dark-gray">
					<div @click="toggleAddressForm" class="flex items-center p-2 hover:bg-gray-100 cursor-pointer border border-t-0 min-h-16">Enter a new address</div>
					<template v-if="addresses?.length">
						<div
							@click="selectAddress(address)"
							v-for="address in addresses"
							:key="address.id"
							class="flex flex-col justify-center p-2 hover:bg-gray-100 cursor-pointer border min-h-16 hover:cursor-pointer hover:shadow-inner"
						>
							<div class="space-x-0.5">
								<span>{{ address.firstName }}</span>
								<span>{{ address.lastName }}</span>
							</div>
							<div>{{ address.company }}</div>
							<div>{{ address.address1 }}</div>
							<div class="space-x-1">
								<span>{{ address.city }},</span>
								<span>{{ address.stateOrProvince }},</span>
								<span>{{ address.postalCode }}</span>
								<span>/ {{ address.country }}</span>
							</div>
						</div>
					</template>
				</div>
			</div>

			<BillingAddressForm :showAddressForm="showBillingDetails" :enableAutoComplete="enableAutoComplete" @continue="$emit('continue')" />

			<!-- <div v-if="store?.user?.id" class="m-auto my-3 items-center flex w-full">
				<div class="flex items-center m-auto w-full pr-4">
					<label class="custom-checkbox relative inline-block overflow-hidden w-4 h-4 bg-transparent rounded border border-gray-300 cursor-pointer mr-2">
						<input type="checkbox" v-model="saveNewAddress" class="absolute opacity-0 w-0 h-0" />
						<span class="checkmark absolute inset-0 flex items-center justify-center hidden text-ihh-white/90 text-lg">✓</span>
					</label>
					<div class="text-ihh-slate-gray text-sm items-center text-start">Save this address in my address book.</div>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
// Components
import BillingAddressForm from '../checkout/billing-address-form.vue'
import { useCheckoutStore } from '../../stores/store.js'

export default {
	name: 'AddressDetails',
	inject: ['store'],
	components: { BillingAddressForm },
	emits: ['saveNewAddress', 'continue', 'addressSelected', 'field-validation'],
	props: {
		addresses: {
			type: Array,
			default: () => [],
		},
		selectedAddress: {
			type: Object,
			default: null,
		},
		enableAutoComplete: {
			type: Boolean,
			default: false,
		},
		showBillingDetails: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			checkout: useCheckoutStore(),
			// UI Variables
			showAddressList: false,
			showAddressForm: false,

			// Data
			saving: false,
			localBillingMatchesShipping: true,
			saveNewAddress: false,
		}
	},
	mounted() {
		// this.localBillingMatchesShipping = this.checkout.shipping.billingMatchesShipping
	},
	methods: {
		toggleAddressList() {
			this.showAddressList = !this.showAddressList
		},
		selectAddress(address) {
			this.updateSelectedAddress(address)

			this.showAddressList = false
			this.showAddressForm = false

			this.$emit('continue')
		},
		toggleAddressForm() {
			this.localBillingMatchesShipping = false
			this.showAddressForm = true
			this.showAddressList = false
		},
		updateSelectedAddress(address) {
			this.localBillingMatchesShipping = false
			this.checkout.setBillingAddress(JSON.parse(JSON.stringify(address)))
		},
	},

	computed: {
		showAddressToggle() {
			return this.addresses?.length
		},
		formattedPhone() {
			const phone = this.selectedAddress?.phone || ''
			const digits = phone.replace(/\D/g, '') // Remove non-numeric characters
			return digits.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') // Format as 512-555-5555
		},
	},

	watch: {
		// localBillingMatchesShipping: {
		// 	handler(newVal) {
		// 		this.checkout.updateBillingMatchesShipping(newVal)

		// 		// Only copy shipping to billing if the checkbox is checked (newVal is true)
		// 		// and this is the billing instance of the component
		// 		if (newVal) {
		// 			this.checkout.copyShippingToBilling()
		// 		}
		// 	},
		// },
		// 'checkout.shipping.billingMatchesShipping': {
		// 	handler(newVal) {
		// 		this.localBillingMatchesShipping = newVal
		// 		this.showAddressList = false
		// 	},
		// },
		saveNewAddress: {
			handler(newVal) {
				console.log('saveNewAddress', newVal)
				this.$emit('saveNewAddress', newVal)
			},
		},
		showBillingDetails: {
			handler(newVal) {
				this.localBillingMatchesShipping = this.checkout.shipping.billingMatchesShipping
			},
		},
	},
}
</script>

<style scoped></style>
<style scoped></style>
